import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraComposerSurface } from '../lieutenants/composer-surface';
import { SpecraPanelHeader } from '../lieutenants/panel-header';
/**
 * Controlled shell for the contextual Assist experience. Conversation and
 * composer behavior stay with the product; the library owns its visual frame.
 */ export function SpecraAssistPanel({ children, className, composer, transcriptRef, headerActions, subtitle, title = 'Assist', ...props }) {
    return /*#__PURE__*/ _jsxs("aside", {
        className: cn('flex h-auto min-h-0 w-full max-w-full flex-col border-t border-border bg-card xl:h-full xl:w-[var(--component-assist-panel-width)] xl:border-l xl:border-t-0', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraPanelHeader, {
                actions: headerActions,
                subtitle: subtitle,
                title: title
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: transcriptRef,
                className: "min-h-0 flex-1 overflow-y-auto px-4 py-5",
                children: /*#__PURE__*/ _jsx("div", {
                    children: children
                })
            }),
            composer ? /*#__PURE__*/ _jsx("footer", {
                className: "shrink-0 border-t border-border p-3",
                children: /*#__PURE__*/ _jsx(SpecraComposerSurface, {
                    children: composer
                })
            }) : null
        ]
    });
}
